export const CHARACTERS_PATH = '/characters'
export const MOVEMENT_PATH = '/movement'
export const SWITCH_PATH = '/switch'
export const ATTACKING_PATH = '/attacking'
export const DEFENDING_PATH = '/defending'
export const OFFENSE_PATH = '/offense'
